<div class="fee-detail-page" [class.fee-detail-page--welcome]="showWelcome">
  <div class="invoice-panel" [class.invoice-panel--collapsed]="!invoiceSummaryExpanded">
    <button
      class="invoice-summary-toggle"
      type="button"
      (click)="toggleInvoiceSummary()"
      [attr.aria-expanded]="invoiceSummaryExpanded">
      <span class="invoice-summary-title">{{ invoiceSummaryTitle }}</span>
      <span class="invoice-period-chevron" [class.open]="invoiceSummaryExpanded" aria-hidden="true"></span>
    </button>

    <div class="invoice-panel-body">
      <div class="invoice-cards">
        <div class="invoice-card">
          <div class="invoice-title">{{ 'fee.dashboard.paid_invoices' | translate:{ count: dashboard.paidCount } }}</div>
          <div class="invoice-value">{{ dashboard.paid | number:'1.0-0' }} ֏</div>
        </div>
        <div class="invoice-card">
          <div class="invoice-title">{{ 'fee.unpaid_invoices' | translate:{ count: dashboard.unpaidCount } }}</div>
          <div class="invoice-value">{{ dashboard.unpaid | number:'1.0-0' }} ֏</div>
        </div>
      </div>

    <button class="invoice-period-toggle" type="button" [matMenuTriggerFor]="showWelcome ? null : invoicePeriodMenu" [disabled]="showWelcome">
      <span class="invoice-period">{{ selectedDashboardPeriod.label | translate }}</span>
      <span class="invoice-period-chevron" aria-hidden="true"></span>
    </button>
    <mat-menu #invoicePeriodMenu="matMenu" xPosition="after" panelClass="invoice-period-menu">
      @for (option of invoicePeriodOptions; track option.value) {
        <button
          mat-menu-item
          type="button"
          class="invoice-period-menu-item"
          [class.active]="option.value === selectedDashboardPeriod.value"
          (click)="selectDashboardPeriod(option)">
          {{ option.label | translate }}
        </button>
      }
    </mat-menu>
    </div>
  </div>

  <div class="welcome-shell">
    <div class="welcome-toolbar">
      <div class="welcome-toolbar-main">
        <div class="welcome-tabs">
        <button class="subgroup-btn"
                [class.active]="activeOverviewTab === 'ALL_MEMBERS'"
                [disabled]="showWelcome"
                (click)="selectOverviewTab('ALL_MEMBERS')">
          {{ 'fee.all_members_payment_history' | translate }} ({{ allMembersPaymentRows.length }})
        </button>
        <button class="subgroup-btn"
                [class.active]="activeOverviewTab === 'GROUPS'"
                [disabled]="showWelcome"
                (click)="selectOverviewTab('GROUPS')">
          {{ 'fee.groups' | translate }} ({{ feeGroups.length }})
        </button>
        <button class="subgroup-btn"
                [class.active]="activeOverviewTab === 'SUBGROUPS'"
                [disabled]="showWelcome"
                (click)="selectOverviewTab('SUBGROUPS')">
          {{ 'fee.tabs.subgroups' | translate }} ({{ subgroupCount }})
        </button>
        <button class="subgroup-btn"
                [class.active]="activeOverviewTab === 'MENTORS'"
                [disabled]="showWelcome"
                (click)="selectOverviewTab('MENTORS')">
          {{ 'fee.mentors' | translate }} ({{ mentorCount }})
        </button>
        </div>

        <div class="search-tools">
          <div class="search-wrap">
            <mat-icon class="search-icon">search</mat-icon>
            <input class="search-input" type="text" [ngModel]="searchQuery" (ngModelChange)="onOverviewSearchChange($event)" [placeholder]="'fee.search_transaction' | translate" [disabled]="showWelcome" />
          </div>
          <div class="search-actions">
            @if (activeOverviewTab === 'GROUPS') {
              <button class="outline-btn" type="button" [disabled]="showWelcome" (click)="addSubgroup()">+ {{ 'fee.add_group' | translate }}</button>
            }
            @if (activeOverviewTab === 'ALL_MEMBERS') {
              <button class="filter-btn"
                      type="button"
                      [class.active]="isPaymentFilterActive"
                      [attr.aria-label]="'fee.filter_transactions' | translate"
                      [disabled]="showWelcome"
                      (click)="openPaymentFilterDialog()">
                <mat-icon>filter_list</mat-icon>
                <span class="filter-label">{{ 'fee.filter' | translate }}</span>
              </button>
            }
          </div>
        </div>
      </div>
    </div>

    @if (showWelcome) {
      <app-fee-welcome-setup
        [industryId]="industryId"
        (setup)="onWelcomeSetup($event)">
      </app-fee-welcome-setup>
    } @else if (activeOverviewTab === 'ALL_MEMBERS') {
    <div class="overview-table-wrap">
      <table class="overview-table">
        <thead>
          <tr>
            <th>{{ 'fee.member_name' | translate }}</th>
            <th>{{ 'fee.passport_or_id_card' | translate }}</th>
            <th>{{ 'fee.group' | translate }}</th>
            <th>{{ 'fee.subgroup' | translate }}</th>
            <th>{{ 'fee.period' | translate }}</th>
            <th>{{ 'fee.paid' | translate }}</th>
            <th>{{ 'fee.due' | translate }}</th>
            <th>{{ 'activity.status' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @if (filteredAllMembersPaymentRows.length === 0) {
            <tr>
              <td colspan="8" class="overview-empty">{{ 'fee.no_payment_records_found' | translate }}</td>
            </tr>
          } @else {
            @for (row of displayedAllMembersPaymentRows; track $index) {
              <tr class="member-row"
                  [class.row-inactive]="row.memberActive === false"
                  (click)="openMemberFromPaymentRow(row.memberId, row.subgroupId)">
                <td class="member-name-link" [attr.data-label]="'fee.member_name' | translate">{{ row.memberName }}</td>
                <td [attr.data-label]="'fee.passport_or_id_card' | translate">{{ row.passportId }}</td>
                <td class="group-name-link" [attr.data-label]="'fee.group' | translate" (click)="$event.stopPropagation(); openGroupPage(row.groupId)">{{ row.groupName }}</td>
                <td class="subgroup-name-link" [attr.data-label]="'fee.subgroup' | translate" (click)="$event.stopPropagation(); openSubgroupPage(row.groupId, row.subgroupId)">{{ row.subgroupName }}</td>
                <td [attr.data-label]="'fee.period' | translate">{{ row.period | localizedMonth }}</td>
                <td [attr.data-label]="'fee.paid' | translate">{{ row.paid | number:'1.0-0' }} ֏</td>
                <td [attr.data-label]="'fee.due' | translate">{{ row.due | number:'1.0-0' }} ֏</td>
                <td [attr.data-label]="'activity.status' | translate">
                  <span class="member-pay-status"
                        [class.member-pay-status--paid]="row.status === 'PAID'"
                        [class.member-pay-status--pending]="row.status === 'PENDING'">
                    @if (row.status === 'PAID') {
                      <mat-icon class="mps-icon">check_circle</mat-icon> {{ 'fee.paid' | translate }}
                    } @else if (row.status === 'PENDING') {
                      <mat-icon class="mps-icon mps-icon--pending">fiber_manual_record</mat-icon> {{ 'fee.status.pending' | translate }}
                    } @else {
                      {{ paymentStatusLabel(row.status) }}
                    }
                  </span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
      @if (hasMoreAllMembersPaymentRows) {
        <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
          @if (!isLoading) {
            <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
            <div class="search-loader">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        </div>
      }
    </div>
    } @else if (activeOverviewTab === 'SUBGROUPS') {
    <div class="overview-table-wrap" [class.menu-open]="isOverviewMenuOpen">
      <table class="overview-table">
        <thead>
          <tr>
            <th>{{ 'fee.subgroup' | translate }}</th>
            <th>{{ 'fee.parent_group' | translate }}</th>
            <th>{{ 'fee.members_qty' | translate }}</th>
            <th>{{ 'fee.start_end_date' | translate }}</th>
            <th>{{ 'fee.mentor' | translate }}</th>
            <th>{{ 'activity.status' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (overviewRows.length === 0) {
            <tr>
              <td colspan="7" class="overview-empty">{{ 'fee.no_records_found' | translate }}</td>
            </tr>
          } @else {
            @for (row of displayedOverviewRows; track $index) {
              <tr class="subgroup-row" (click)="openSubgroupPage(row.groupId, row.subgroupId)">
                <td class="subgroup-name-link" [attr.data-label]="'fee.subgroup' | translate">{{ row.subgroupName }}</td>
                <td [attr.data-label]="'fee.parent_group' | translate">{{ row.parentGroupName }}</td>
                <td [attr.data-label]="'fee.members_qty' | translate">{{ row.membersQty }}</td>
                <td [attr.data-label]="'fee.start_end_date' | translate">{{ row.startEndDate }}</td>
                <td [attr.data-label]="'fee.mentor' | translate">{{ row.mentorName }}</td>
                <td [attr.data-label]="'activity.status' | translate">
                  <span class="overview-status" [ngClass]="statusClass(row.status)">
                    <span class="overview-status-icon-shape" [ngClass]="statusClass(row.status)" aria-hidden="true"></span>
                    {{ statusLabel(row.status) }}
                  </span>
                </td>
                <td class="overview-more" (click)="$event.stopPropagation()">
                  <button class="more-btn"
                          type="button"
                          (click)="toggleSubgroupMenu($event, row.subgroupId)"
                          [attr.aria-label]="'fee.subgroup_actions' | translate">
                    ⋮
                  </button>
                  @if (openedSubgroupMenuId === row.subgroupId) {
                    <div class="more-menu" (click)="$event.stopPropagation()">
                      @if (!isSubgroupCompleted(row.subgroupId)) {
                        <button type="button" class="more-menu-item" (click)="editSubgroupFromOverview(row.subgroupId)">
                          <span>{{ 'fee.edit_subgroup' | translate }}</span>
                          <mat-icon>edit</mat-icon>
                        </button>
                      }
                      <button type="button" class="more-menu-item" (click)="deleteSubgroupFromOverview(row.subgroupId)">
                        <span>{{ 'fee.delete_subgroup' | translate }}</span>
                        <mat-icon>delete_outline</mat-icon>
                      </button>
                    </div>
                  }
                </td>
              </tr>
              @if (isMembersOpen && activeSubgroup?.id === row.subgroupId) {
                <tr class="subgroup-members-row">
                  <td colspan="7">
                    <div class="members-inline-wrap">
                      <div class="members-actions members-actions--inline">
                        <button class="outline-btn" type="button" (click)="addMemberInline()">+ {{ 'fee.actions.add_member' | translate }}</button>
                      </div>

                      @if (newMemberForm.length > 0) {
                        <div class="new-members-forms">
                          @for (memberGroup of newMemberForm.controls; track $index) {
                            <div class="new-member-card" [class.collapsed]="!newMemberMetas[$index].expanded">
                              <div class="new-member-header" (click)="toggleMemberInline($index)">
                                <div class="new-member-title">
                                  @if (newMemberMetas[$index].saved) {
                                    <mat-icon class="saved-icon">check_circle</mat-icon>
                                  }
                                  {{ getMemberControl($index, 'userName').value || ('fee.new_member' | translate) }}
                                </div>
                                <button type="button"
                                        class="remove-member-btn"
                                        (click)="removeMemberInline($index); $event.stopPropagation()"
                                        [disabled]="newMemberMetas[$index].saved">
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>

                              @if (newMemberMetas[$index].expanded) {
                                <div class="new-member-body">
                                  <div class="form-row">
                                    <div class="form-field">
                                      <label>{{ 'fee.user_name' | translate }} *</label>
                                      <input type="text"
                                             class="form-input"
                                             [formControl]="getMemberControl($index, 'userName')"
                                             [placeholder]="'fee.enter_name' | translate" />
                                      @if (getMemberControl($index, 'userName').touched && getMemberControl($index, 'userName').hasError('required')) {
                                        <span class="error-text">{{ 'fee.validation.user_name_required' | translate }}</span>
                                      }
                                    </div>

                                    <div class="form-field">
                                      <label>{{ 'fee.passport_or_id_card' | translate }} *</label>
                                      <input type="text"
                                             class="form-input"
                                             [formControl]="getMemberControl($index, 'passportId')"
                                             [placeholder]="'fee.enter_id' | translate" />
                                      @if (getMemberControl($index, 'passportId').touched && getMemberControl($index, 'passportId').hasError('required')) {
                                        <span class="error-text">{{ 'fee.validation.passport_id_required' | translate }}</span>
                                      }
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    <div class="form-field">
                                      <label>{{ 'fee.phone' | translate }} *</label>
                                      <input type="text"
                                             class="form-input"
                                             [formControl]="getMemberControl($index, 'phone')"
                                             [placeholder]="'fee.enter_phone' | translate" />
                                      @if (getMemberControl($index, 'phone').touched && getMemberControl($index, 'phone').hasError('required')) {
                                        <span class="error-text">{{ 'fee.validation.phone_required' | translate }}</span>
                                      }
                                      @if (getMemberControl($index, 'phone').touched && getMemberControl($index, 'phone').hasError('pattern')) {
                                        <span class="error-text">{{ 'fee.validation.invalid_phone_number' | translate }}</span>
                                      }
                                    </div>

                                    <div class="form-field">
                                      <label>{{ 'fee.email' | translate }} *</label>
                                      <input type="email"
                                             class="form-input"
                                             [formControl]="getMemberControl($index, 'email')"
                                             [placeholder]="'fee.enter_email' | translate" />
                                      @if (getMemberControl($index, 'email').touched && getMemberControl($index, 'email').hasError('required')) {
                                        <span class="error-text">{{ 'fee.validation.email_required' | translate }}</span>
                                      }
                                      @if (getMemberControl($index, 'email').touched && getMemberControl($index, 'email').hasError('email')) {
                                        <span class="error-text">{{ 'fee.validation.invalid_email_format' | translate }}</span>
                                      }
                                    </div>
                                  </div>

                                  <div class="form-row">
                                    <div class="form-field">
                                      <label>{{ 'fee.frequency' | translate }} *</label>
                                      <select class="form-input" [formControl]="getMemberControl($index, 'frequency')">
                                        <option value="">{{ 'fee.select_frequency' | translate }}</option>
                                        <option value="DAILY_SINGLE_PAY">{{ 'fee.frequency_types.DAILY_SINGLE_PAY' | translate }}</option>
                                        <option value="DAILY">{{ 'fee.frequency_types.DAILY' | translate }}</option>
                                        <option value="WEEKLY">{{ 'fee.frequency_types.WEEKLY' | translate }}</option>
                                        <option value="MONTHLY">{{ 'fee.frequency_types.MONTHLY' | translate }}</option>
                                        <option value="ANNUAL">{{ 'fee.frequency_types.ANNUAL' | translate }}</option>
                                      </select>
                                      @if (getMemberControl($index, 'frequency').touched && getMemberControl($index, 'frequency').hasError('required')) {
                                        <span class="error-text">{{ 'fee.validation.frequency_required' | translate }}</span>
                                      }
                                    </div>

                                    <div class="form-field">
                                      <label>{{ 'fee.date_of_birth' | translate }}</label>
                                      <input type="date"
                                             class="form-input"
                                             [formControl]="getMemberControl($index, 'dateOfBirth')" />
                                    </div>
                                  </div>

                                  <div class="form-actions">
                                    <button type="button"
                                            class="save-member-btn"
                                            [disabled]="newMemberMetas[$index].saved"
                                            (click)="saveMemberInline($index)">
                                      {{ (newMemberMetas[$index].saved ? 'fee.saved' : 'fee.save_member') | translate }}
                                    </button>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }

                      <div class="overview-table-wrap members-inline-table-wrap">
                        <table class="members-table">
                          <thead>
                          <tr>
                            <th>{{ 'user_card.name' | translate }}</th>
                            <th>{{ 'fee.frequency' | translate }}</th>
                            <th>{{ 'fee.discount' | translate }}</th>
                            <th>{{ 'fee.due' | translate }}</th>
                            <th>{{ 'fee.total' | translate }}</th>
                            <th>{{ 'activity.status' | translate }}</th>
                            <th>{{ 'fee.deactivate' | translate }}</th>
                          </tr>
                          </thead>
                          <tbody>
                            @if (filteredSubgroupMembers.length === 0) {
                              <tr>
                                <td colspan="7" class="overview-empty">{{ 'fee.no_members_found_for_subgroup' | translate }}</td>
                              </tr>
                            } @else {
                              @for (item of displayedSubgroupMembers; track item.id) {
                                <tr [class.row-inactive]="item.active === false">
                                  <td class="member-name-link" (click)="openMemberProfile(item)">{{ item.name }}</td>
                                  <td>{{ frequencyLabel(item.frequency) }}</td>
                                  <td>{{ item.discount }}</td>
                                  <td>{{ item.due }}</td>
                                  <td>{{ item.total }}</td>
                                  <td>
                                    <span class="member-pay-status"
                                          [class.member-pay-status--paid]="item.status === 'PAID'"
                                          [class.member-pay-status--pending]="item.status === 'PENDING'"
                                          [class.member-pay-status--overdue]="item.status === 'OVERDUE'">
                                      @if (item.status === 'PAID') {
                                        <mat-icon class="mps-icon">check_circle</mat-icon> {{ 'fee.paid' | translate }}
                                      } @else if (item.status === 'PENDING') {
                                        <mat-icon class="mps-icon mps-icon--pending">fiber_manual_record</mat-icon> {{ 'fee.status.pending' | translate }}
                                      } @else {
                                        {{ paymentStatusLabel(item.status) }}
                                      }
                                    </span>
                                  </td>
                                  <td (click)="$event.stopPropagation()">
                                    <label class="toggle">
                                      <input type="checkbox" [checked]="item.active ?? true" (change)="toggleMemberActive(item, $event)">
                                      <span class="toggle-ui"></span>
                                    </label>
                                  </td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                        @if (hasMoreSubgroupMembers) {
                          <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
                            @if (!isLoading) {
                              <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
                              <div class="search-loader">
                                <div class="spinner-border" role="status">
                                  <span class="visually-hidden">Loading...</span>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
      @if (hasMoreSubgroupRows) {
        <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
          @if (!isLoading) {
            <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
            <div class="search-loader">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          }
        </div>
      }
    </div>

    } @else if (activeOverviewTab === 'GROUPS') {
      <div class="overview-table-wrap" [class.menu-open]="isOverviewMenuOpen">
        <table class="overview-table">
          <thead>
          <tr>
            <th>{{ 'fee.group' | translate }}</th>
            <th>{{ 'fee.tabs.subgroups' | translate }}</th>
            <th>{{ 'fee.members_qty' | translate }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            @if (groupOverviewRows.length === 0) {
              <tr>
                <td colspan="4" class="overview-empty">{{ 'fee.no_records_found' | translate }}</td>
              </tr>
            } @else {
              @for (row of displayedGroupOverviewRows; track $index) {
                <tr class="group-row" (click)="openGroupPage(row.groupId)">
                  <td class="group-name-link" [attr.data-label]="'fee.group' | translate">{{ row.groupName }}</td>
                  <td [attr.data-label]="'fee.tabs.subgroups' | translate">
                    @for (name of row.subgroupNames.split(','); track $index) {
                      <div>{{ name.trim() }}</div>
                    }
                  </td>
                  <td [attr.data-label]="'fee.members_qty' | translate">{{ row.membersQty }}</td>
                  <td class="overview-more" (click)="$event.stopPropagation()">
                    <button class="more-btn"
                            type="button"
                            (click)="toggleGroupMenu($event, row.groupId)"
                            [attr.aria-label]="'fee.group_actions' | translate">
                      ⋮
                    </button>
                    @if (openedGroupMenuId === row.groupId) {
                      <div class="more-menu" (click)="$event.stopPropagation()">
                        <button type="button" class="more-menu-item" (click)="editGroupFromOverview(row.groupId)">
                          <span>{{ 'fee.edit_group' | translate }}</span>
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="more-menu-item" (click)="deleteGroupFromOverview(row.groupId)">
                          <span>{{ 'fee.delete_group' | translate }}</span>
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
        @if (hasMoreGroupRows) {
          <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
            @if (!isLoading) {
              <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
              <div class="search-loader">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="overview-table-wrap" [class.menu-open]="isOverviewMenuOpen">
        <table class="overview-table">
          <thead>
          <tr>
            <th>{{ 'fee.mentor' | translate }}</th>
            <th>{{ 'fee.phone' | translate }}</th>
            <th>{{ 'fee.email' | translate }}</th>
            <th>{{ 'fee.groups' | translate }}</th>
            <th>{{ 'fee.tabs.subgroups' | translate }}</th>
            <th>{{ 'fee.total' | translate }}</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            @if (mentorOverviewRows.length === 0) {
              <tr>
                <td colspan="7" class="overview-empty">{{ 'fee.no_records_found' | translate }}</td>
              </tr>
            } @else {
              @for (row of displayedMentorOverviewRows; track $index) {
                <tr>
                  <td [attr.data-label]="'fee.mentor' | translate">{{ row.mentorName }}</td>
                  <td [attr.data-label]="'fee.phone' | translate">{{ row.mentorPhone }}</td>
                  <td [attr.data-label]="'fee.email' | translate">{{ row.mentorEmail }}</td>
                  <td [attr.data-label]="'fee.groups' | translate">
                    @for (group of row.groupLinks; track group.id) {
                      <div class="group-name-link overview-link-plain" (click)="openGroupPage(group.id)">{{ group.name }}</div>
                    }
                  </td>
                  <td [attr.data-label]="'fee.tabs.subgroups' | translate">
                    @for (subgroup of row.subgroupLinks; track subgroup.id) {
                      <div class="subgroup-name-link overview-link-plain" (click)="openSubgroupPage(subgroup.groupId, subgroup.id)">{{ subgroup.name }}</div>
                    }
                  </td>
                  <td [attr.data-label]="'fee.total' | translate">{{ row.amountTotal | number:'1.0-0' }} ֏</td>
                  <td class="overview-more" (click)="$event.stopPropagation()">
                    <button class="more-btn"
                            type="button"
                            (click)="toggleMentorMenu($event, row.mentorName)"
                            [attr.aria-label]="'fee.mentor_actions' | translate">
                      ⋮
                    </button>
                    @if (openedMentorMenuKey === row.mentorName.toLowerCase()) {
                      <div class="more-menu" (click)="$event.stopPropagation()">
                        <button type="button" class="more-menu-item" (click)="editMentorFromOverview(row)">
                          <span>{{ 'fee.edit_mentor' | translate }}</span>
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="more-menu-item" (click)="deleteMentorFromOverview(row)">
                          <span>{{ 'fee.delete_mentor' | translate }}</span>
                          <mat-icon>delete_outline</mat-icon>
                        </button>
                      </div>
                    }
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
        @if (hasMoreMentorRows) {
          <div class="fee-load-more-row d-flex justify-content-center mt-4 flex-direction-row gap-10px">
            @if (!isLoading) {
              <button class="load-history-button" type="button" (click)="loadMore()">{{ 'my_team.load_more' | translate }}</button>
              <div class="search-loader">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
